import Highlighter from "react-highlight-words";
import { Link } from "react-router-dom";
import "./SearchPage.scss";

const SearchPageContent = (props) => {
  var host = window.location.host;
  var protocol = window.location.protocol;
  return (
    <div className="search-title">
      <div className="search-label">
        문서명/본문 검색 :{" "}
        <span className="search-count">'{props.contentList?.length}'</span> 건
      </div>
      <table>
        <thead>
          <tr>
            <th></th>
            <th>매뉴</th>
            <th>문서명</th>
            <th>본문</th>
          </tr>
        </thead>
        <tbody>
          {props.contentList?.map((item, index) => {
            return (
              <tr key={index}>
                <td>{index}</td>
                <td>
                  {item.path[0]} {">"} {item.path[1]}
                </td>
                <td>
                  <Link
                    to={`${protocol}//${host}/${props.basePath}${item.url}`}
                  >
                    <span className="search-title-table-title">
                      <Highlighter
                        highlightClassName="search-highlight"
                        searchWords={[props.value] ?? ""}
                        autoEscape={true}
                        textToHighlight={item.title ?? ""}
                      />
                    </span>
                  </Link>
                </td>
                <td>
                  <Link
                    to={`${protocol}//${host}/${props.basePath}${item.url}`}
                    className="bookmark-link"
                  >
                    <Highlighter
                      highlightClassName="search-highlight"
                      searchWords={[props.value] ?? ""}
                      autoEscape={true}
                      textToHighlight={item.contentText ?? ""}
                    />
                  </Link>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
export default SearchPageContent;
